"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Common Configuration for copy-content on the elevator site.
 */
var typographyVariables = {
  headers: {
    fontWeight: 700,
    fontFamily: 'Open Sans, sans-serif',
    color: 'rgba(38, 38, 38, 0.90)'
  },
  body: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    color: 'rgba(38, 38, 38, 0.90)'
  },
  subtitles: {
    fontFamily: 'Roboto, sans-serif',
    fontWeight: 700
  }
};

/**
 * Override default MUI typography type-face for copy-content
 * components
 */
var typographyConfig = {
  typography: {
    h1: _objectSpread({}, typographyVariables.headers),
    h2: _objectSpread({}, typographyVariables.headers),
    h3: _objectSpread({}, typographyVariables.headers),
    h4: _objectSpread({}, typographyVariables.headers),
    h5: _objectSpread({}, typographyVariables.headers),
    h6: _objectSpread({}, typographyVariables.headers),
    body1: _objectSpread({}, typographyVariables.body),
    body2: _objectSpread({}, typographyVariables.body),
    subtitle1: _objectSpread({}, typographyVariables.subtitles),
    subtitle2: _objectSpread({}, typographyVariables.subtitles)
  }
};
var _default = exports.default = typographyConfig;